var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrossIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.63316 9.83275C9.90758 9.55832 9.90758 9.1134 9.63316 8.83897L6.15544 5.36125L9.63412 1.88257C9.90854 1.60815 9.90854 1.16322 9.63412 0.888802C9.3597 0.61438 8.91477 0.614379 8.64035 0.888802L5.16167 4.36748L1.68299 0.8888C1.40856 0.614378 0.963638 0.614378 0.689215 0.8888C0.414793 1.16322 0.414793 1.60815 0.689215 1.88257L4.16789 5.36125L0.69017 8.83898C0.415747 9.1134 0.415747 9.55833 0.69017 9.83275C0.964592 10.1072 1.40952 10.1072 1.68394 9.83275L5.16167 6.35502L8.63939 9.83275C8.91381 10.1072 9.35874 10.1072 9.63316 9.83275Z",
    fill: "#191D23"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossIcon2);
export default __webpack_public_path__ + "static/media/cross_icon_2.9ed908a5c2b59dfacfece936fa93172f.svg";
export { ForwardRef as ReactComponent };